import { render } from "./ImageQuadEditModal.vue?vue&type=template&id=676639d6&scoped=true"
import script from "./ImageQuadEditModal.vue?vue&type=script&lang=js"
export * from "./ImageQuadEditModal.vue?vue&type=script&lang=js"

import "./ImageQuadEditModal.vue?vue&type=style&index=0&id=676639d6&scoped=true&lang=less"
import "./ImageQuadEditModal.vue?vue&type=style&index=1&id=676639d6&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676639d6"]])

export default __exports__